import { ActionTypes } from "../constants/action-types";

/*
Wishlist Action Types with payload
*/

export const initializeWishlist = (wishlist) => {
  return {
    type: ActionTypes.INITIALIZE_WISHLIST,
    payload: wishlist,
  };
};

export const addToWishlist = (wishlist) => {
  return {
    type: ActionTypes.ADD_TO_WISHLIST,
    payload: wishlist,
  };
};

export const removeFromWishlist = (wishlist) => {
  return {
    type: ActionTypes.REMOVE_FROM_WISHLIST,
    payload: wishlist,
  };
};

export const favouriteIconAnimationEnd = (wishlist) => {
  return {
    type: ActionTypes.FAVOURITE_ICON_ANIMATION_END,
    payload: wishlist,
  };
};

export const openWishlistSidebar = (wishlist) => {
  return {
    type: ActionTypes.OPEN_WISHLIST_SIDEBAR,
    payload: wishlist,
  };
};

export const setWishlistLoadingState = (wishlist) => {
  return {
    type: ActionTypes.SET_WISHLIST_LOADING_STATE,
    payload: wishlist,
  }
}

export const wishlistNotInit = (wishlist) => {
  return {
    type: ActionTypes.WISHLIST_NOT_INITIALISED,
    payload: wishlist,
  };
};
